<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div>
        POČETAK
        <DateTimePicker format="YYYY-MM-DD hh:mm a" v-model="arrivalTimeSlot.startOfTimeSlot" />
      </div>
      <div>
        KRAJ
        <DateTimePicker format="YYYY-MM-DD hh:mm a" v-model="arrivalTimeSlot.endOfTimeSlot" />
      </div>
      <div>
        MAKSIMALAN BROJ POSJETITELJA
        <input type="number" min="0" v-model="arrivalTimeSlot.timeSlotCapacity" />
      </div>
      <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="isArrivalTimeSlotInvalid" v-on:click="$emit('save', arrivalTimeSlot)">
          SPREMI
        </button>
        <button type="button" v-on:click="$emit('cancel', arrivalTimeSlot)">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', arrivalTimeSlot)"></a>
  </div>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
  name: 'AddEditArrivalTimeSLot',
  props: {
    arrivalTimeSlot: {},
  },
  components: {
    DateTimePicker,
  },
  computed: {
    isArrivalTimeSlotInvalid: function() {
      if (
        !this.arrivalTimeSlot.endOfTimeSlot ||
        !this.arrivalTimeSlot.startOfTimeSlot ||
        !this.arrivalTimeSlot.timeSlotCapacity
      )
        return true;

      return (
        new Date(this.arrivalTimeSlot.endOfTimeSlot) <= new Date(this.arrivalTimeSlot.startOfTimeSlot) ||
        Number(this.arrivalTimeSlot.timeSlotCapacity) <= 0
      );
    },
  },
  methods: {},
};
</script>
